import { Select } from "antd";
import React from "react";
import { CC_INFO } from "../../../constants/constant";

const CookChildren = (props) => {
    return (
        <>
            <Select {...props} getPopupContainer={(triggerNode) => triggerNode.parentElement} allowClear>
                {CC_INFO?.map((data) => {
                    return (
                        <Select.Option key={data?.id} value={data.id}>
                            {data?.name}
                        </Select.Option>
                    );
                })}
            </Select>
        </>
    );
};
export default CookChildren;
